import { NgModule } from '@angular/core';

// IMPORTS
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { MomentModule } from 'angular2-moment';
import { TranslateModule } from "@ngx-translate/core";  // TranslateService

// DECLARATIONS / EXPORTS
import { FootcardComponent } from 'src/app/components/footcard/footcard.component';
import { MyapiinfoComponent } from 'src/app/components/myapiinfo/myapiinfo.component';
// import { MygeofenceComponent } from 'src/app/components/mygeofence/mygeofence.component';
import { MycameraComponent } from 'src/app/components/mycamera/mycamera.component';   // see NOTE**
import { MyeventsiteComponent } from 'src/app/components/myeventsite/myeventsite.component';
import { MyquestionnaireComponent } from 'src/app/components/myquestionnaire/myquestionnaire.component';
import { MyfooterComponent } from 'src/app/components/myfooter/myfooter.component';   // see NOTE**
import { MygeoinfoComponent } from 'src/app/components/mygeoinfo/mygeoinfo.component';
import { MyloadingComponent } from 'src/app/components/myloading/myloading.component';   // see NOTE**
// import { MymenubadgeComponent } from 'src/app/components/mymenubadge/mymenubadge.component';   // see NOTE**
import { MysortheaderComponent } from 'src/app/components/mysortheader/mysortheader.component';   // see NOTE**
import { MystatusComponent } from 'src/app/components/mystatus/mystatus.component';   // see NOTE**

// https://stackoverflow.com/questions/53185901/ionic-4-custom-components
// https://www.joshmorony.com/setting-up-custom-components-in-ionic/

@NgModule({
  imports: 
  [
      CommonModule
    , IonicModule  // PETER -- note!!
    , FormsModule // PETER -- note!!
    , MomentModule // PETER -- note!!
    //, TranslateModule  // PETER -- note!!
    , TranslateModule.forChild() // https://phraseapp.com/blog/posts/localizing-ionic-applications-with-ngx-translate/
  ]
  ,
  declarations: 
  [   FootcardComponent
    , MyapiinfoComponent 
    // , MygeofenceComponent
    , MycameraComponent 
    , MyeventsiteComponent
    , MyquestionnaireComponent
    , MyfooterComponent 
    , MygeoinfoComponent 
    , MyloadingComponent 
    //, MymenubadgeComponent 
    , MysortheaderComponent 
    , MystatusComponent 
  ]
  ,
  exports: 
  [   FootcardComponent
    , MyapiinfoComponent 
    // , MygeofenceComponent
    , MycameraComponent 
    , MyeventsiteComponent
    , MyquestionnaireComponent
    , MyfooterComponent 
    , MygeoinfoComponent 
    , MyloadingComponent 
    //, MymenubadgeComponent 
    , MysortheaderComponent 
    , MystatusComponent 
  ]
})
export class ComponentsModule { }
